import { useState } from 'react';
import { toast } from 'react-toastify';
import { VehicleFormType } from '../../components/FormVehicleType/validations';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import history from '../../services/history';

export default function UseUpdateVehicleType() {
  const [loading, setLoading] = useState(false);

  async function execute(data: VehicleFormType, vehicleTypeId: string) {
    try {
      setLoading(true);
      const response = await api.put(
        `v1/backoffice/vehicleType/${vehicleTypeId}`,
        {
          vehicleType: data.vehicleType,
          costPerAssistant: data.costPerAssistant,
          costPerKilometer: data.costPerKilometer,
          costPerOrder: data.costPerOrder,
          costPerCubicMeter: Number(data.costPerCubicMeter),
          costPerTon: data.costPerTon,
          driverCost: data.driverCost,
          packLoadWeight: data.packLoadWeight * 100,
          payloadCapacity: data.payloadCapacity * 100,
        },
      );

      if (response.status === 200) {
        toast.success(ToastMessages.vehicleType.success.updateVehicleType);
        history.push('/home/vehicle-types');
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.vehicleType.error.updateVehicleType);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
